import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";
import EditGroupForm from "../Forms/EditGroupForm";

interface EditGroupModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onCancel: () => void;
  defaultInfo: any;
}

const EditGroupModal: FC<EditGroupModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  defaultInfo,
}) => {
  const handleSubmit = () => {
    onSubmit?.(); // Refetch queries in software section
    handleClose();
  };

  const handleClose = () => {
    onClose?.();
  };
  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <EditGroupForm
        width={550}
        defaultFormData={defaultInfo}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Modal>
  );
};

export default EditGroupModal;
